import { useEffect } from 'react';

/**
 * Sets the page title.
 *
 * @param {string} sPageTitle - Page title
 */
const usePageTitle = (sPageTitle) => {
  useEffect(() => {
    document.title = `${sPageTitle} - WakeNetwork`;

    return () => {
      document.title = 'WakeNetwork';
    };
  }, [sPageTitle]);
};

export default usePageTitle;
